module.exports = __webpack_public_path__ + "static/media/KE.d35eb79a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/KE.svg
// module id = 2182
// module chunks = 7